import styled from 'styled-components';

export const DivTicket = styled.div`
    .topic{
        text-align: justify;
        padding: 1rem 0;
    }
`;